module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": "0.2rem 0 1rem 0",
      "height": "100%"
    }
  }, [(false) ? _c('van-cell-group', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ClubSearchIndex'
      }),
      expression: "{ name: 'ClubSearchIndex' }"
    }],
    attrs: {
      "title": "我的俱乐部",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'QcxjSearchIndex'
      }),
      expression: "{ name: 'QcxjSearchIndex' }"
    }],
    attrs: {
      "title": "我的考级中心（点）",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianList'
      }),
      expression: "{ name: 'DakejianList' }"
    }],
    attrs: {
      "title": "校园大课间啦啦操推广实施单位申报",
      "is-link": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row2 flex-start"
  }, [_c('div', {
    staticClass: "row2-li"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ClubSearchIndex'
      }),
      expression: "{ name: 'ClubSearchIndex' }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/icon-club-large.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-tip",
    staticStyle: {
      "color": "#50b0ff"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.certRow.club.length) + "家\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row2-li"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'QcxjSearchIndex'
      }),
      expression: "{ name: 'QcxjSearchIndex' }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/icon-qcxj-large.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-tip",
    staticStyle: {
      "color": "#57e1ab"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.certRow.exame_center.length) + "家\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row2-li"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianList'
      }),
      expression: "{ name: 'DakejianList' }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/icon-dakejian-large.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-tip",
    staticStyle: {
      "color": "#d12adf"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.certRow.dakejian && _vm.certRow.dakejian.length > 0 ?
    "已申报" :
    "未申报") + "\n      ")])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CRuralList'
      }),
      expression: "{name: 'CRuralList'}"
    }],
    attrs: {
      "is-link": ""
    }
  }, [_vm._v("全国啦啦操乡村振兴公益活动")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row4"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ActivityActivity',
        query: {
          id: 65
        }
      }),
      expression: "{ name: 'ActivityActivity', query: { id: 65 } }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/bg-qicaiwenhuaqu.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ChaSearchExame',
        query: {}
      }),
      expression: "{ name: 'ChaSearchExame', query: {} }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/bg-chaxun.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 101
        }
      }),
      expression: "{ name: 'NewsList', query: { cate_id: 101 } }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/bg-kaojizhibo.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 99
        }
      }),
      expression: "{ name: 'NewsList', query: { cate_id: 99 } }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/bg-fengcaizhanshi.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row5"
  }, [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ExameApplyListDanwei',
        query: {
          cate_id: 5
        }
      }),
      expression: "{ name: 'ExameApplyListDanwei', query: { cate_id: 5 } }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/bg-kaojifabu.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 98
        }
      }),
      expression: "{ name: 'NewsList', query: { cate_id: 98 } }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/bg-zhengcejiedu.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 104
        }
      }),
      expression: "{ name: 'NewsList', query: { cate_id: 104 } }"
    }],
    attrs: {
      "src": require("../../../assets/images/qcxj/bg-yijianfankui.png")
    }
  })]), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('van-tabs', {
    class: _vm.row.bg_show ? 'active-tab' : '',
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onClick
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.activeTab), function(item, index) {
    return _c('van-tab', {
      key: index,
      attrs: {
        "type": index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [(item.num > 0) ? _c('span', {
            staticClass: "active-tab-num"
          }, [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v("\n            " + _vm._s(item.name) + "\n          ")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.row.list.list), function(item, i) {
      return _c('div', [(item.style == '-1') ? _c('div', {
        directives: [{
          name: "rblink",
          rawName: "v-rblink",
          value: ({
            name: 'NewsDetail',
            query: {
              id: item.id
            }
          }),
          expression: "{ name: 'NewsDetail', query: { id: item.id } }"
        }]
      }, [(item.pics.length == 0) ? _c('NewsItem1', {
        attrs: {
          "row": item
        }
      }) : _vm._e(), _vm._v(" "), (item.pics.length == 1) ? _c('NewsItem2', {
        attrs: {
          "row": item
        }
      }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (item.pics.length > 1) ? _c('NewsItem4', {
        attrs: {
          "row": item
        }
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.style == '1') ? _c('Activity1', {
        attrs: {
          "content": item,
          "index": i
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '2') ? _c('Activity2', {
        attrs: {
          "content": item,
          "index": i
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '3') ? _c('Activity3', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '4') ? _c('Activity4', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.style == '5') ? _c('Activity5', {
        attrs: {
          "content": item,
          "index": i
        },
        on: {
          "sendBox": function($event) {
            return _vm.onSendBox($event, item, i)
          },
          "loginStatus": function($event) {
            return _vm.onLoginStatus($event)
          },
          "deleteActive": function($event) {
            return _vm.onDeleteActive($event, item, i)
          },
          "deleteComment": function($event) {
            return _vm.onDeleteComment($event, i)
          }
        }
      }) : _vm._e()], 1)
    })], 2)
  }), 1), _vm._v(" "), (_vm.sendShow) ? _c('div', {
    staticClass: "comment-bottom"
  }, [_c('div', {
    staticClass: "send-comment"
  }, [_c('van-field', {
    attrs: {
      "placeholder": _vm.placeholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send-btn",
    on: {
      "click": _vm.onCommentSend
    }
  }, [_vm._v("发送")])], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-293739d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjClubIndex.vue
// module id = 1356
// module chunks = 0